export const environment = {
  production: false,
  LRNEXT_API_URL : 'https://api.next.test.legalresources.com',
  LRNEXT_APP_URL : 'https://app.next.test.legalresources.com',
  ENROLLMENT_APP_URL: 'https://enrollment.test.legalresources.com',
  NUMBER_ITEMS_PAGE_LIST : 25,
};

